import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl } from 'framework/routing';

const ACCOUNTING_CYCLE_PATH = '/accounting-cycles';

export const getAccountingCycleListUrl = () => ACCOUNTING_CYCLE_PATH;

export const getAccountingCycleRouterPath = () => `${ACCOUNTING_CYCLE_PATH}/*`;

export const useAccountingCycleRoute = () =>
  createRoute({
    listRoute: ACCOUNTING_CYCLE_PATH,
  });

export const useAccountingCycleUrl = () => useEntityUrl({ baseLink: ACCOUNTING_CYCLE_PATH });

export const useAccountingCycleId = () => useParams<Dictionary<string>>().id!;
